import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'ramda';
import { is, List, Map } from 'immutable';

import styleFile from './AvailRoomDetailPreferences.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import Form from '@synergycms_core/components/generic/Form';
import actions from '../../../../store/actions';
import { cleanHotelPreferences, immutablePick } from '../../../../utils';
import RichText from '@synergycms_core/components/generic/RichText';
import { RoomPreference } from '../../RoomPreference';

const { customer: customerActions } = actions;

class AvailRoomDetailPreferences extends React.Component {
  static displayName = 'AvailRoomDetailPreferences';
  render() {
    const { theme } = this.props;
    const { segment, roomPreferences, hotelPreferences } = this.props.config;
    const { classes } = theme.styles;
    return (
      hotelPreferences &&
      hotelPreferences.size > 0 && (
        <div className={theme.computedInnerStyle}>
          <div className={classes.applyPadding}>
            <Form onBlur={this.onBlur} innerStyle={classes.gray}>
              <ul className={[classes.clearfix, classes.gray].join(' ')}>
                {roomPreferences &&
                  roomPreferences.map(roomPreference => {
                    if (roomPreference.preference_id.indexOf('room_preference_') !== -1) {
                      roomPreference.preference_id = roomPreference.preference_id.split('room_preference_')[1];
                    }
                    const optionId = roomPreference.option_id;
                    const preference = hotelPreferences.find(
                      preference => preference.get('id') === roomPreference.preference_id
                    );
                    return (
                      <li key={`${segment}-${preference.get('id')}`} className={classes['selectContainer']}>
                        <div className={classes.preference}>
                          <RoomPreference preference={preference} optionId={optionId} />
                        </div>
                      </li>
                    );
                  })}
              </ul>
              <div className={classes.gray}>
                <RichText innerStyle={[classes.message, classes.gray].join(' ')} translate={true} ucFirst={true}>
                  _%selecciona tus preferencias. Las señaladas con asterisco no están garantizadas con la reserva pero
                  haremos lo posible por satisfacerlas%_
                </RichText>
              </div>
            </Form>
          </div>
        </div>
      )
    );
  }

  onBlur = (validForm, inputList) => {
    const preferences = Object.entries(inputList).reduce((preferences, [preferenceId, data]) => {
      preferences.push({
        preference_id: preferenceId,
        option_id: data.value.get('id')
      });
      return preferences;
    }, []);

    const {
      roomId,
      occupGroupId,
      serviceId,
      changeRoomsPreferences,
      changeRoomPreferences,
      segment,
      isSelected
    } = this.props.config;

    // Always update AvailAccordion state
    changeRoomsPreferences(roomId, occupGroupId, serviceId, preferences);

    if (isSelected) {
      // If room is selected update store too
      changeRoomPreferences(segment, preferences);
    }
  };
}

const mapDispatchToProps = dispatch => {
  return {
    changeRoomPreferences: (idx, preferences) => {
      dispatch(customerActions.reservationRequest.addRoomPreferences(idx, preferences));
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const { segment, roomId, serviceId, occupGroupId } = ownProps;

  const roomRateSelected = store.getIn(['customer', 'reservation_request', 'blocks', segment - 1], Map());

  const currentRoom = Map({
    idx: segment,
    occup_group_id: occupGroupId,
    room_id: roomId,
    service_id: serviceId
  });

  return {
    hotelPreferences: cleanHotelPreferences(store.getIn(['hotels', hotelId, 'preferences'], List())),
    isSelected: is(currentRoom, immutablePick(roomRateSelected)(...currentRoom.keySeq()))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'segment',
    'roomId',
    'serviceId',
    'occupGroupId',
    'hotelPreferences',
    'isSelected',
    'changeRoomsPreferences',
    'changeRoomPreferences',
    'roomPreferences'
  ]),
  withThemeJSS({ styleFile, index: 300 })
)(AvailRoomDetailPreferences);
